import React, { useState, useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { graphql, useStaticQuery } from 'gatsby';

import { Icon, Link } from '@printdeal/ui-library';

import { registerEventOpenPhoneNumber } from '../../helpers/dataLayerHelpers/PhoneNumberWidgetHelper';

interface PhoneNumberProps {
  widgetClasses: string;
  iconClasses: string;
  componentLocation: string;
}

const phoneQuery = graphql`
  query PhoneNumberWidget {
    configuration: portalConfiguration {
      officeAddress {
        phoneNumber
        phoneNumberFromAbroad
      }
    }
  }
`;

const PhoneNumberWidget = ({
  widgetClasses, iconClasses, componentLocation,
}: PhoneNumberProps) => {
  const { configuration: { officeAddress: { phoneNumberFromAbroad = '', phoneNumber = '' } = {} } = {} } = useStaticQuery(phoneQuery);
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const handleOnClick = useCallback(() => {
    setIsOpen(true);
    registerEventOpenPhoneNumber(componentLocation);
  }, [setIsOpen, componentLocation]);

  if (!(phoneNumberFromAbroad || phoneNumber)) return null;

  return (
    <div className={`pd-flex pd-gap-2 pd-text-sm ${widgetClasses}`}>
      <Icon icon="phone" className={iconClasses} />
      <div className="pd-grow">
        {!isOpen ? (
          // eslint-disable-next-line jsx-a11y/anchor-is-valid
          <Link as="button" onClick={handleOnClick} variant="secondary">
            <FormattedMessage id="widget.callUs.text" defaultMessage="Call us" />
            <Icon icon="chevron-down" />
          </Link>
        ) : (
          <FormattedMessage id="widget.callUs.text" defaultMessage="Call us" />
        )}{
          isOpen && (
            <div>
              {phoneNumberFromAbroad ? (
                <>
                  {phoneNumber && (
                    <p className="pd-mb-1 pd-pt-2">
                      <FormattedMessage id="widget.callUs.be" defaultMessage="Belgium" />
                      <Link href={`tel:${phoneNumber}`} variant="secondary">
                        : {phoneNumber}
                      </Link>
                    </p>
                  )}
                  <p>
                    <FormattedMessage id="widget.callUs.abroad" defaultMessage="Abroad" />
                    <Link href={`tel:${phoneNumberFromAbroad}:`} variant="secondary">
                      : {phoneNumberFromAbroad}
                    </Link>
                  </p>
                </>
              ) : (
                <Link href={`tel:${phoneNumber}`} variant="secondary">
                  {phoneNumber}
                </Link>
              )}
            </div>
          )
        }
      </div>
    </div>
  );
};

export default PhoneNumberWidget;
